// extracted by mini-css-extract-plugin
module.exports = {"sign__section":"SignSection_sign__section__EQSiO","share":"SignSection_share__BMpcA"};